import {
  DocumentPdfPane,
  type DocumentPaneRenderProps,
  type DocumentViewerHighlight,
} from '@aecom-ai-engineering/react-components';
import { type FC } from 'react';

export interface PdfRendererOptions {
  highlights?: DocumentViewerHighlight[];
  initialPage?: number;
  searchable?: boolean;
  continuousScroll?: boolean;
}

interface PdfRendererPaneProps extends DocumentPaneRenderProps {
  options?: PdfRendererOptions;
}

export const PdfRendererPane: FC<PdfRendererPaneProps> = ({ options, ...props }) => (
  <DocumentPdfPane
    active={props.active}
    caption={props.caption}
    fileName={props.fileName}
    onSidebarContextChange={props.onSidebarContextChange}
    src={props.src}
    searchable={options?.searchable ?? true}
    continuousScroll={options?.continuousScroll ?? true}
    highlights={options?.highlights}
    initialPage={options?.initialPage}
  />
);

export function createPdfRenderer(options?: PdfRendererOptions) {
  return function PdfRenderer(props: DocumentPaneRenderProps) {
    return <PdfRendererPane {...props} options={options} />;
  };
}
